module.exports = __webpack_public_path__ + "static/media/service4.a9b8ea6e.png";